
import ModalCodigo from "@/components/ModalCodigo.vue";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    name: String,
    icone: String,
    idcon: String,
    userName: String,
    cardNumber: String,
    cardExpiring: String,
    typeCard: String,
    cardFlag: String,
    id: Number,
    toDo: Function,
    isMainCard: Boolean,
    onChange: Function,
    deletar: Function,
  },
  components: { ModalCodigo },
})
export default class OptionCollapse extends Vue {
  fullMethodSelected: any = JSON.parse(
    sessionStorage.getItem("FULL_METHOD_SELECTED") || "{}"
  );

  mounted() {
    const elems = document.querySelectorAll(".collapsible");
    const instances = M.Collapsible.init(elems, {});
  }
}
